export enum SeatingOrderType {
  SET_SEATING_ORDER_STATE = 'SET_SEATING_ORDER_STATE',
  SEAT_ADDED = 'SEAT_ADDED',
  SEAT_UPDATED = 'SEAT_UPDATED',
  SEAT_REMOVED = 'SEAT_REMOVED',
  SET_SEAT_ENTRY = 'SET_SEAT_ENTRY',
  REMOVE_SEAT_ENTRY = 'REMOVE_SEAT_ENTRY',
  NOT_PERMITTED_TO_APPLY_SEATING_ORDER_CHANGE = 'NOT_PERMITTED_TO_APPLY_SEATING_ORDER_CHANGE',
  NO_SEATING_ORDER_OBJECT_FOUND = 'NO_SEATING_ORDER_OBJECT_FOUND',
  ADDED_PARTICIPANT_SYNC_SEAT_ENTRY = 'ADDED_PARTICIPANT_SYNC_SEAT_ENTRY',
  REMOVED_PARTICIPANT_SEAT_SEAT_ENTRY = 'REMOVED_PARTICIPANT_SEAT_SEAT_ENTRY',
  SEATING_ORDER_SYNC_LISTENERS_ADDED = 'SEATING_ORDER_SYNC_LISTENERS_ADDED'
}
